import { spacing, styled, Text } from '@thg-commerce/enterprise-theme'
import { TextEntry } from '@thg-commerce/gravity-theme'

export const Title = styled.p`
  padding: ${spacing(1)} ${spacing(2)};
`

export const StyledListItem = styled.li<{ hasUrl?: boolean }>`
  ${Text('bodyText', 'alternate')};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  :hover {
    cursor: ${(props) => (props.hasUrl ? 'pointer' : 'initial')};
  }
  a {
    padding-left: ${spacing(2)};
    padding-right: ${spacing(2)};
  }
  a:hover {
    padding-left: ${spacing(2)};
    padding-right: ${spacing(2)};
  }
  a:focus {
    padding-left: ${spacing(2)};
    padding-right: ${spacing(2)};
  }
`

export const StyledText = styled.p<{ size: TextEntry }>`
  ${(props) => Text(props.size, 'alternate')};
`
